import StoryblokClient from 'storyblok-js-client';

export const StoryBlok = {
  getClient: () => {
    return new StoryblokClient({
      accessToken: '17RrACmk3E9yvf9VJFQuogtt'
    })
  },
  getRequestConfig: () => {
    return {
      version: 'published'
    }
  },
};
